export const changeLangFunc = () => {
    return {
        type: 'changeLangAction',
    }
}

export const changeModeFunc = () => {
    return {
        type: 'changeModeAction',
    }
}

export const changeCookieFunc = () => {
    return {
        type: 'changeCookieAction',
    }
}